import { z } from 'zod'
import { corporateAccountAllPermissionsSchema } from './corporate-account-all-permissions'

/** 企業帳號 - 權限設定 Schema */
export const corporateAccountPermissionsSchema = z.object({
  /** 單元功能 */
  unitPermissions: corporateAccountAllPermissionsSchema.pick({
    unitCrossIndCoop: true,
    unitShoppingCart: true,
    unitMyAcct: true
  }),
  /** 禮遇兌換管理 */
  giftPermissions: corporateAccountAllPermissionsSchema.pick({
    giftPointDetail: true,
    giftCourtesyExchange: true,
    giftCourtesyAssign: true
  }),
  /** 員工名單管理 */
  employeePermissions: corporateAccountAllPermissionsSchema.pick({
    employeeList: true,
    employeeSendInvitation: true,
    employeeInvitationHistory: true
  }),
  /** 差旅金額統計 */
  tvlAmountPermissions: corporateAccountAllPermissionsSchema.pick({
    tvlAmountCurrent: true,
    tvlAmountHistory: true,
    tvlAmountThold: true
  })
})

/** 企業帳號 - 權限設定 */
export interface CorporateAccountPermissions
  extends z.infer<typeof corporateAccountPermissionsSchema> {}

export class CorporateAccountPermissions {
  constructor(value = true) {
    return {
      unitPermissions: {
        unitCrossIndCoop: value,
        unitShoppingCart: value,
        unitMyAcct: value
      },
      giftPermissions: {
        giftPointDetail: value,
        giftCourtesyExchange: value,
        giftCourtesyAssign: value
      },
      employeePermissions: {
        employeeList: value,
        employeeSendInvitation: value,
        employeeInvitationHistory: value
      },
      tvlAmountPermissions: {
        tvlAmountCurrent: value,
        tvlAmountHistory: value,
        tvlAmountThold: value
      }
    }
  }
}
